import { IOrgChartDepartmentInfo } from "@vierkant-software/types__api";
import { AutoSyncServiceBase } from "./sync.service";
import { Injectable } from "@angular/core";

export enum DepartmentDetailLevel {
    default = 0
}

export interface DepartmentInfo {
    ID: string;
    departmentInfo: IOrgChartDepartmentInfo;
    isActive: boolean;
}

type DepartmentDetailType = {
    [DepartmentDetailLevel.default]: DepartmentInfo;
};

@Injectable({ providedIn: "root" })
export class DepartmentSyncService extends AutoSyncServiceBase<DepartmentDetailType, DepartmentDetailLevel> {
    override getDefaultValue(): DepartmentDetailType[DepartmentDetailLevel] {
        return {} as DepartmentDetailType[DepartmentDetailLevel];
    }
    protected readonly syncName = "departmentSync";
}
